import "core-js/modules/es7.symbol.async-iterator";
import "core-js/modules/es6.symbol";
export var DEFAULT_EPS = 1e-6;
/**
 * Internal use only. **Do NOT use in user land code!**
 *
 * @internal
 */

export var SEMAPHORE = Symbol();